import { render, staticRenderFns } from "./inspectionRecord.vue?vue&type=template&id=0df7782c&scoped=true&"
import script from "./inspectionRecord.vue?vue&type=script&lang=js&"
export * from "./inspectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./inspectionRecord.vue?vue&type=style&index=0&id=0df7782c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7782c",
  null
  
)

export default component.exports